import {ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IAngularMyDpOptions, IMyDateModel} from '@nodro7/angular-mydatepicker';
import {dateOptions, timeZone} from '../../../shared/data/config';
import {DatePipe} from '@angular/common';
import {AuthService} from '../../../shared/service/auth.service';
import {CreatorService} from '../../../shared/service/creator.service';
import {ClassService} from '../../../shared/service/class.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {IDropdownSettings} from 'ng-multiselect-dropdown/multiselect.model';

@Component({
    selector: 'app-confirm-content-assign',
    templateUrl: './confirm-content-assign.component.html',
    styleUrls: ['./confirm-content-assign.component.scss']
})
export class ConfirmContentAssignComponent implements OnInit {

    @Input() classData: any = [];
    @Input() isEssay: any = '0';
    @Input() contentDetails: any = {};
    @Input() multiContentId: any = [];
    /** When set (from pre-confirm "Assign To" step), applies Class vs Content Folder like content library `selectAssignType`. */
    @Input() initialAssignTypeSelection: '1' | '2' | null = null;
    @Output() closePopUp: any = new EventEmitter<any>();
    /** Assign To: Login As–style dropdown */
    public assignToChoiceOpen = false;

    @HostListener('document:click', ['$event'])
    onDocumentClickCloseAssignToMenu(event: MouseEvent): void {
        if (!this.assignToChoiceOpen) {
            return;
        }
        const t = event.target as HTMLElement;
        if (!t.closest('.assign-to-loginas-wrap')) {
            this.assignToChoiceOpen = false;
        }
    }

    public setDate = new Date().toLocaleString('en-US', { timeZone: timeZone.location });
    public dateValidation = true;
    public showClassRelatedField = false;
    public showContentFolderRelatedField = false;
    myDpOptions: IAngularMyDpOptions = {
        dateRange: false,
        dateFormat: dateOptions.pickerFormat,
        firstDayOfWeek: 'su',
        disableUntil: {
            year: new Date(this.setDate).getFullYear(),
            month: new Date(this.setDate).getMonth() + 1,
            day: new Date(this.setDate).getDate() != 1 ? new Date(this.setDate).getDate() - 1 : -1,
        },
    };
    myDpOptions1: IAngularMyDpOptions = {
        dateRange: false,
        dateFormat: dateOptions.pickerFormat,
        firstDayOfWeek: 'su',
        disableUntil: {
            year: this.myDpOptions.disableUntil.year,
            month: this.myDpOptions.disableUntil.month,
            day: this.myDpOptions.disableUntil.day
        },
    };
    myDpOptions2: IAngularMyDpOptions = {
        dateRange: false,
        dateFormat: dateOptions.pickerFormat,
        firstDayOfWeek: 'su',
        disableUntil: {
            year: this.myDpOptions.disableUntil.year,
            month: this.myDpOptions.disableUntil.month,
            day: this.myDpOptions.disableUntil.day
        },
    };
    /** Match content-home assign modal datepicker positioning in modals */
    contentScheduleMyDpOptionsStart: IAngularMyDpOptions;
    contentScheduleMyDpOptionsEnd: IAngularMyDpOptions;
    /** End-date picker options for "Set Common Date & Time" bulk row */
    commonBulkEndDpOptions: IAngularMyDpOptions;
    /** Collapsible class schedule cards (multi-class); fixed single-class path keeps body open */
    assignClassScheduleCollapsible = false;
    expandAssignClassSchedules: { [classId: string]: boolean } = {};
    public showStudentList: boolean;
    public assignForm: FormGroup;
    public studentData = [];
    public choosedData = [];
    public meridian = true;
    public spinner = false;
    public endDate: any;
    public startdate: any;
    public contentAssignedForm = '';
    public model: { singleDate: { jsDate: Date }; isRange: boolean };
    public assignType = '1';
    public classListData = [];
    public classDataSample = [];
    public teacherListData = [];
    public contentFolderListData = [];
    public releaseGrade: any = '';
    public contentType: any = '1';
    public checkQuestion: any = '0';
    public allowScore = false;
    public contentFormat = '1';
    public topicsData: any = [];
    public settingList: any = [];
    public downloadContentAvailable = false;
    public selectedClassName = '';
    public timeRestrict = false;
    public assignContentToStudent: IDropdownSettings = {
        singleSelection: false,
        idField: 'student_id',
        textField: 'name',
        enableCheckAll: true,
        selectAllText: 'Select all',
        unSelectAllText: 'UnSelect all',
        allowSearchFilter: true,
        limitSelection: -1,
        clearSearchFilter: true,
        maxHeight: 139,
        itemsShowLimit: 5,
        searchPlaceholderText: 'Search Student',
        noDataAvailablePlaceholderText: 'No data available',
        closeDropDownOnSelection: false,
        showSelectedItemsAtTop: false,
    };

    constructor(public formBuilder: FormBuilder, public datePipe: DatePipe, public auth: AuthService, public creatorService: CreatorService,
                public classService: ClassService, public router: Router, public toastr: ToastrService,
                private cdr: ChangeDetectorRef) {
        this.model = {isRange: false, singleDate: {jsDate: new Date()}};
        this.contentAssignedForm = this.auth.getSessionData('assignedForm');
        this.assignForm = this.formBuilder.group({
            class: [''],
            downloadcontent: [''],
            releaseScore: ['0'],
            startDate: [''],
            endDate: [''],
            startTime: [''],
            endTime: [''],
            specificstudent: [[]],
            typeSelection: [this.contentAssignedForm == 'classRoom' ? '1' : 'n/a'],
            contentFolder: [null],
            classSelect: [[]],
            teacherSelect: [null],
            topicSelect: [null],
            batch: [null],
            workspace: false,
            is_fullscreen: false,
            showTimer: false,
            feedback: false,
            timeRestrict: false,
            dateRanges: this.formBuilder.array([]),
            classContentDateRanges: this.formBuilder.array([]),
            commonBulk: this.formBuilder.group({
                startDate: [this.createTodayDateModel()],
                endDate: [null as IMyDateModel | null],
                startTime: [{hour: 0, minute: 0, second: 0}],
                endTime: [{hour: 23, minute: 59, second: 0}]
            })
        });
        this.settingList = JSON.parse(this.auth.getSessionData('settingList')) ?? [];
        console.log(this.settingList, 'settingList');
        this.showStudentList = false;
        this.contentScheduleMyDpOptionsStart = {...this.myDpOptions2, appendSelectorToBody: true};
        this.contentScheduleMyDpOptionsEnd = {...this.myDpOptions1, appendSelectorToBody: true};
        this.commonBulkEndDpOptions = {...this.myDpOptions1, appendSelectorToBody: true};
    }

    ngOnInit(): void {
        if (this.contentAssignedForm == 'class') {
            this.assignType = '1';
            this.showClassRelatedField = true;
            this.showContentFolderRelatedField = false;
            this.liststudent([this.classData[0].class_id]);
            this.topicsList([this.classData[0].class_id]);
            this.addClassDate();
            this.assignForm.controls.releaseScore.patchValue(this.isEssay == '1' ? '1' : '0');
            this.assignForm.controls.classSelect.patchValue(this.classData[0].class_name ? [this.classData[0].class_id] : []);
            this.patchValue();
            this.assignForm.controls.typeSelection.patchValue('1');
        } else if (this.contentAssignedForm == 'content-Folder') {
            this.assignType = '2';
            this.contentFolderList();
            this.showContentFolderRelatedField = true;
            this.showClassRelatedField = false;
            this.assignForm.controls.typeSelection.patchValue('2');
        } else {
            this.classData = [];
            this.classList();
            this.contentFolderList();
            this.assignForm.controls.releaseScore.patchValue(this.isEssay == '1' ? '1' : '0');
            const stObject = {hour: parseInt('00'), minute: parseInt('00'), second: parseInt('00')};
            this.assignForm.controls.startTime.patchValue(stObject);
            const etObject = {hour: parseInt('23'), minute: parseInt('59'), second: parseInt('00')};
            this.assignForm.controls.endTime.patchValue(etObject);
            if (this.contentAssignedForm == 'classRoom') {
                this.assignForm.controls.typeSelection.patchValue('1');
                this.typeSelection();
            }
        }
        this.teacherList();
        this.assignClassScheduleCollapsible = this.showClassRelatedField && this.contentAssignedForm !== 'class';
        if (this.multiContentId.length == 0) {
            this.contentType = this.contentDetails.content_type;
            this.releaseGrade = this.contentDetails.allow_autograde;
            this.checkQuestion = this.contentDetails.without_question;
            this.contentFormat = this.contentDetails.content_format;
            this.downloadContentAvailable = true;
            this.allowScore = this.releaseGrade == '1' && this.contentType != '1';
            this.timeRestrict = this.contentType == '3';
        } else {
            this.downloadContentAvailable = this.multiContentId.some(code => code.download == '1');
            this.timeRestrict = this.multiContentId.some(value => value.content_type == '3');
            this.allowScore = this.settingList[2]?.value == 1 ?? true;
        }
        this.refreshExpandAssignClassSchedules();
        const preset = this.initialAssignTypeSelection;
        if (preset === '1' || preset === '2') {
            setTimeout(() => this.selectAssignType(preset), 0);
        }
    }

    toggleAssignToChoice(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.assignToChoiceOpen = !this.assignToChoiceOpen;
    }

    /** `assignedForm` session: show Class tile unless content-folder-only flow */
    showConfirmClassAssignTile(): boolean {
        return this.contentAssignedForm !== 'content-Folder';
    }

    /** Show Content Folder tile unless topic-class or classRoom */
    showConfirmFolderAssignTile(): boolean {
        return this.contentAssignedForm !== 'class' && this.contentAssignedForm !== 'classRoom';
    }

    get dateRanges(): FormArray {
        return this.assignForm.get('dateRanges') as FormArray;
    }

    get classContentDateRanges(): FormArray {
        return this.assignForm.get('classContentDateRanges') as FormArray;
    }

    /** Per-content schedule rows when multiple contents are assigned (content library parity). */
    addClassContentDatePicker(classData = {class_id: '', class_name: '', start_date: '', end_date: ''},
                              contentData = {content_id: '', name: ''}, previousData: any = null) {
        const stObject = {hour: parseInt('00', 10), minute: parseInt('00', 10), second: parseInt('00', 10)};
        const etObject = {hour: parseInt('23', 10), minute: parseInt('59', 10), second: parseInt('00', 10)};
        return this.formBuilder.group({
            startDate: [previousData?.startDate ?? this.createTodayDateModel()],
            endDate: [previousData?.endDate ?? null],
            startTime: [previousData?.startTime ?? stObject],
            endTime: [previousData?.endTime ?? etObject],
            class_id: [classData.class_id],
            class_name: [classData.class_name],
            class_startDate: [classData.start_date],
            class_endDate: [classData.end_date],
            content_id: [contentData.content_id],
            content_name: [contentData.name ?? (contentData as any).content_name ?? '']
        });
    }

    /** Library multi-select (1 or more items): one schedule row per content per class with content name visible. */
    usesPerContentScheduleRows(): boolean {
        return this.multiContentId.length >= 1;
    }

    syncClassContentDateRanges(): void {
        if (this.multiContentId.length === 0) {
            this.classContentDateRanges.clear();
            return;
        }
        const previousRows = this.classContentDateRanges.value || [];
        const selectedClasses = this.dateRanges.value || [];
        this.classContentDateRanges.clear();
        selectedClasses.forEach((classData: any) => {
            this.expandAssignClassSchedules[classData.class_id] = this.expandAssignClassSchedules[classData.class_id] ?? true;
            this.multiContentId.forEach((content: any) => {
                const previousData = previousRows.find(
                    (row: any) => row.class_id == classData.class_id && row.content_id == content.content_id);
                this.classContentDateRanges.push(this.addClassContentDatePicker(classData, {
                    content_id: content.content_id,
                    name: content.name ?? content.content_name ?? ''
                }, previousData));
            });
        });
        this.initCommonBulkSchedulePanel();
    }

    getClassContentRanges(classId: string | number): AbstractControl[] {
        return this.classContentDateRanges.controls.filter(
            (control: AbstractControl) => (control as FormGroup).controls.class_id.value == classId);
    }

    applyClassContentDateToAll(classId: string | number): void {
        const ranges = this.getClassContentRanges(classId) as FormGroup[];
        if (ranges.length <= 1) {
            return;
        }
        const firstVal = ranges[0].getRawValue();
        for (let i = 1; i < ranges.length; i++) {
            ranges[i].patchValue({
                startDate: firstVal.startDate,
                endDate: firstVal.endDate,
                startTime: firstVal.startTime,
                endTime: firstVal.endTime
            });
        }
    }

    addDatePicker(classData = {class_id: '', class_name: '', start_date: '', end_date: ''}) {

        const stObject = { hour: parseInt('00'), minute: parseInt('00'), second: parseInt('00') };
        const etObject = { hour: parseInt('23'), minute: parseInt('59'), second: parseInt('00') };
        return this.formBuilder.group({
            startDate: [null],
            endDate: [null],
            startTime: [stObject],
            endTime: [etObject],
            class_startDate: [classData.start_date],
            class_endDate: [classData.end_date],
            class_id: [classData.class_id],
            class_name: [classData.class_name]
        });
    }

    removeSelectedMultiContent(data, index) {
        this.multiContentId.splice(index, 1);
        if (this.assignType === '1') {
            this.syncClassContentDateRanges();
        }
    }

    addClassDate(classData = {class_id: '', class_name: '', start_date: '', end_date: ''}) {
        this.dateRanges.push(this.addDatePicker(classData));
        this.refreshExpandAssignClassSchedules();
    }

    removeDatePicker(index: number) {
        this.dateRanges.removeAt(index);
    }

    onDateChanged(event: IMyDateModel): void {
        this.myDpOptions1 = {};
        this.myDpOptions1 = {
            dateRange: false,
            dateFormat: dateOptions.pickerFormat,
            firstDayOfWeek: 'su',
            disableUntil: {
                year: event.singleDate.date.year,
                month: event.singleDate.date.month,
                day: event.singleDate.date.day - 1
            },
        };
        this.contentScheduleMyDpOptionsEnd = {...this.myDpOptions1, appendSelectorToBody: true};
    }

    onDateChanged1(event: any): void {
        this.myDpOptions.disableSince = event.date;
    }

    topicsList(classID) {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            class_id: classID,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        this.classService.topicList(data).subscribe((successData: any) => {
            if (successData.IsSuccess) {
                this.topicsData = successData.ResponseObject;
            }}, (error) => {
                console.log(error, 'error_topicList');
        });
    }

    checkTimeDifference(formControl) {
        if (formControl.value.startDate && formControl.value.endDate) {
            if (formControl.value.startDate.singleDate.jsDate && formControl.value.endDate.singleDate.jsDate) {
                const startDate = this.datePipe.transform(formControl.value.startDate.singleDate.jsDate, 'yyyy-MM-dd');
                const endDate = this.datePipe.transform(formControl.value.endDate.singleDate.jsDate, 'yyyy-MM-dd');
                if (formControl.value.startTime && formControl.value.endTime) {
                    const startTime = parseInt(formControl.value.startTime.hour);
                    const startTimeHour = parseInt(formControl.value.startTime.minute);
                    const endTime = parseInt(formControl.value.endTime.hour);
                    const endTimeHour = parseInt(formControl.value.endTime.minute);
                    const totalStartTimeMins = (startTime * 60) + startTimeHour;
                    const totalendTimeHour = (endTime * 60) + endTimeHour;
                    if (startDate == endDate) {
                        return totalStartTimeMins >= totalendTimeHour;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    typeSelection() {
        const selectedValue = this.assignForm.controls.typeSelection.value;
        console.log(selectedValue, 'selected');
        if (selectedValue == 1 || selectedValue == '1') {
            this.showContentFolderRelatedField = false;
            this.showClassRelatedField = true;
            this.assignType = '1';
        } else if (selectedValue == 2 || selectedValue == '2') {
            this.clearFormArray();
            this.showContentFolderRelatedField = true;
            this.showClassRelatedField = false;
            this.assignType = '2';
            this.startdate = '';
            this.endDate = '';
            this.assignForm.controls.classSelect.patchValue([]);
            const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
            const dropped = dr1.split('-');
            const droppedObject: IMyDateModel = {
                isRange: false,
                singleDate: {jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2]))},
                dateRange: null
            };
            this.assignForm.controls.startDate.patchValue(droppedObject);
        }
        this.assignForm.controls.workspace.patchValue(false);
        this.assignForm.controls.is_fullscreen.patchValue(false);
        this.assignForm.controls.feedback.patchValue(false);
        this.assignClassScheduleCollapsible = this.showClassRelatedField && this.contentAssignedForm !== 'class';
        this.allowScore = this.multiContentId.length == 0 ? this.releaseGrade == '1' && this.contentType != '1' :
            this.settingList[2]?.value == 1 ?? true;
        if (this.assignType === '1') {
            this.syncClassContentDateRanges();
        }
    }

    /** Login As–style choice: Class vs Content Folder (updates typeSelection control). */
    selectAssignType(value: '1' | '2', event?: Event): void {
        event?.stopPropagation();
        this.assignForm.controls.typeSelection.patchValue(value);
        this.typeSelection();
        this.assignToChoiceOpen = false;
    }

    toggleAssignClassSchedule(classId: string) {
        if (!this.assignClassScheduleCollapsible) {
            return;
        }
        this.expandAssignClassSchedules[classId] = !this.expandAssignClassSchedules[classId];
    }

    refreshExpandAssignClassSchedules() {
        this.dateRanges.controls.forEach((c: AbstractControl) => {
            const id = (c as FormGroup).controls.class_id.value;
            if (id !== undefined && id !== null && this.expandAssignClassSchedules[id] === undefined) {
                this.expandAssignClassSchedules[id] = true;
            }
        });
    }

    /** Drop expand state for classes no longer in dateRanges (e.g. after ng-select change). */
    private pruneExpandAssignClassSchedules() {
        const allowed = new Set(
            this.dateRanges.value.map((row: { class_id: string }) => row.class_id).filter((id) => id != null && id !== '')
        );
        Object.keys(this.expandAssignClassSchedules).forEach((k) => {
            if (!allowed.has(k)) {
                delete this.expandAssignClassSchedules[k];
            }
        });
    }

    private dateFromPickerModel(model: any): Date | null {
        if (!model || !model.singleDate) {
            return null;
        }
        const sd = model.singleDate;
        if (sd.jsDate) {
            return new Date(sd.jsDate);
        }
        if (sd.epoc != null) {
            return new Date(sd.epoc);
        }
        if (sd.date?.year != null && sd.date?.month != null && sd.date?.day != null) {
            return new Date(sd.date.year, sd.date.month - 1, sd.date.day);
        }
        return null;
    }

    private isStartDateAfterEndDate(startModel: any, endModel: any): boolean {
        const s = this.dateFromPickerModel(startModel);
        const e = this.dateFromPickerModel(endModel);
        if (!s || !e) {
            return false;
        }
        s.setHours(0, 0, 0, 0);
        e.setHours(0, 0, 0, 0);
        return s.getTime() > e.getTime();
    }

    contentRangeHasInvalidDates(row: AbstractControl): boolean {
        const g = row as FormGroup;
        return this.isStartDateAfterEndDate(g.controls.startDate.value, g.controls.endDate.value);
    }

    private validateAssignDateRanges(): boolean {
        if (this.assignType !== '1' || (!this.showClassRelatedField && this.contentAssignedForm !== 'class')) {
            this.dateValidation = true;
            return true;
        }
        if (this.usesPerContentScheduleRows()) {
            for (const ctrl of this.classContentDateRanges.controls) {
                if (this.contentRangeHasInvalidDates(ctrl)) {
                    this.dateValidation = false;
                    return false;
                }
            }
        } else {
            for (const ctrl of this.dateRanges.controls) {
                if (this.contentRangeHasInvalidDates(ctrl)) {
                    this.dateValidation = false;
                    return false;
                }
            }
        }
        this.dateValidation = true;
        return true;
    }

    clearFormArray() {
        this.dateRanges.clear();
        this.classContentDateRanges.clear();
        this.expandAssignClassSchedules = {};
    }

    applyToAll(data) {
        console.log(data, 'data');
        this.assignForm.get('dateRanges').value.forEach((control, index) => {
            const formControlName = this.assignForm['controls'].dateRanges['controls'][index]['controls'];
            if (index != 0) {
                console.log('function');
                formControlName.startDate.patchValue(data.value.startDate);
                formControlName.endDate.patchValue(data.value.endDate);
                formControlName.startTime.patchValue(data.value.startTime);
                formControlName.endTime.patchValue(data.value.endTime);
            }
        });
    }

    private createTodayDateModel(): IMyDateModel {
        return {isRange: false, singleDate: {jsDate: new Date()}, dateRange: null};
    }

    /** Initialize bulk “Set Common Date & Time” row — start date defaults to today (content library parity) */
    initCommonBulkSchedulePanel(): void {
        if (this.usesPerContentScheduleRows()) {
            if (!this.classContentDateRanges.length) {
                return;
            }
        } else if (!this.dateRanges.length) {
            return;
        }
        const bulk = this.assignForm.get('commonBulk') as FormGroup;
        bulk.patchValue({
            startDate: this.createTodayDateModel(),
            endDate: null,
            startTime: {hour: 0, minute: 0, second: 0},
            endTime: {hour: 23, minute: 59, second: 0}
        });
        this.refreshCommonBulkEndDateOptions();
    }

    onCommonBulkStartDateChanged(_event: IMyDateModel): void {
        this.refreshCommonBulkEndDateOptions();
    }

    refreshCommonBulkEndDateOptions(): void {
        const bulk = this.assignForm.get('commonBulk') as FormGroup;
        const start = bulk.get('startDate').value as IMyDateModel;
        const jd = this.dateFromPickerModel(start);
        if (!jd) {
            this.commonBulkEndDpOptions = {...this.myDpOptions1, appendSelectorToBody: true};
            return;
        }
        const y = jd.getFullYear();
        const m = jd.getMonth() + 1;
        const d = jd.getDate();
        this.commonBulkEndDpOptions = {
            dateRange: false,
            dateFormat: dateOptions.pickerFormat,
            firstDayOfWeek: 'su',
            disableUntil: {year: y, month: m, day: d - 1},
            appendSelectorToBody: true
        };
    }

    private deepCloneDateModel(model: IMyDateModel | null): IMyDateModel | null {
        if (!model) {
            return null;
        }
        const jd = this.dateFromPickerModel(model);
        if (!jd) {
            return null;
        }
        return {isRange: false, singleDate: {jsDate: new Date(jd.getTime())}, dateRange: null};
    }

    applyCommonDateTimeToAllContent(): void {
        const bulk = this.assignForm.get('commonBulk') as FormGroup;
        const startModel = bulk.get('startDate').value as IMyDateModel;
        const endModel = bulk.get('endDate').value as IMyDateModel | null;
        const startTime = bulk.get('startTime').value;
        const endTime = bulk.get('endTime').value;
        if (!this.dateFromPickerModel(startModel)) {
            this.toastr.error('Please select a start date.');
            return;
        }

        if (!endModel) {
            this.toastr.error('Please select a end date.');
            return;
        }
        if (endModel && this.isStartDateAfterEndDate(startModel, endModel)) {
            this.toastr.error('End date must be on or after start date.');
            return;
        }
        if (this.usesPerContentScheduleRows() && this.classContentDateRanges.length) {
            this.classContentDateRanges.controls.forEach((c) => {
                (c as FormGroup).patchValue({
                    startDate: this.deepCloneDateModel(startModel),
                    endDate: this.deepCloneDateModel(endModel),
                    startTime: {...startTime},
                    endTime: {...endTime}
                });
            });
        } else if (this.dateRanges.length) {
            this.dateRanges.controls.forEach((c) => {
                (c as FormGroup).patchValue({
                    startDate: this.deepCloneDateModel(startModel),
                    endDate: this.deepCloneDateModel(endModel),
                    startTime: {...startTime},
                    endTime: {...endTime}
                });
            });
        } else {
            return;
        }
        this.cdr.detectChanges();
    }

    updateClassName() {
        this.selectedClassName = '';
        const classID = this.assignForm.controls.classSelect.value;
        this.classData.forEach((items) => {
            if (classID.some((data => data == items.class_id))) {
                this.selectedClassName = this.selectedClassName == '' ? items.class_name :
                    this.selectedClassName + ', ' + items.class_name;
            }
        });
    }

    selectStudent() {
        const classID = this.assignForm.controls.classSelect.value;
        console.log(classID, 'classID');
        const selectedClass = [];
        this.classListData.forEach((items) => {
            if (classID.some((data => data == items.class_id))) {
                selectedClass.push(items);
            }
        });
        if (classID.length != 0) {
            this.topicsList(classID);
        } else {
            this.assignForm.controls.batch.patchValue(null);
        }
        console.log(selectedClass, 'selectedClass');
        selectedClass.forEach((item) => {
            const classIds = this.assignForm.get('dateRanges').value.map(control => control.class_id);
            if (!classIds.includes(item.class_id)) {
                this.addClassDate(item);
                this.assignForm.controls.specificstudent.patchValue([]);
                // this.classbatchid = selectedClass[0].batch_id;
            }
        });

        this.assignForm.get('dateRanges').value.forEach((control, index) => {
            const classId = control.class_id;
            const existsInEvent = selectedClass.some(item => item.class_id === classId);
            const formControlName = this.assignForm['controls'].dateRanges['controls'][index]['controls'];
            if (!existsInEvent) {
                this.removeDatePicker(index);
            }
            selectedClass.forEach((items) => {
                if (items.class_id == classId) {
                    if (items.start_date != '0000-00-00') {
                        const sd = items.end_date.split('-');
                        const sdObject: IMyDateModel = {
                            isRange: false,
                            singleDate: { jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2])) },
                            dateRange: null
                        };
                        const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
                        const dropped = dr1.split('-');
                        const droppedObject: IMyDateModel = {
                            isRange: false,
                            singleDate: { jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2])) },
                            dateRange: null
                        };
                        formControlName.startDate.patchValue(droppedObject);
                        this.myDpOptions2 = {};
                        this.myDpOptions2 = {
                            dateRange: false,
                            dateFormat: dateOptions.pickerFormat,
                            firstDayOfWeek: 'su',
                            disableUntil: {
                                year: this.myDpOptions.disableUntil.year,
                                month: this.myDpOptions.disableUntil.month,
                                day: this.myDpOptions.disableUntil.day
                            }
                        };
                        formControlName.class_startDate.patchValue(items.start_date);
                    } else {
                        const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
                        const dropped = dr1.split('-');
                        const droppedObject: IMyDateModel = {
                            isRange: false,
                            singleDate: { jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2])) },
                            dateRange: null
                        };
                        formControlName.startDate.patchValue(droppedObject);
                    }
                    if (items.end_date != '0000-00-00') {
                        const sd = items.end_date.split('-');
                        const sdObject: IMyDateModel = {
                            isRange: false,
                            singleDate: { jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2])) },
                            dateRange: null
                        };
                        this.myDpOptions1 = {};
                        this.myDpOptions1 = {
                            dateRange: false,
                            dateFormat: dateOptions.pickerFormat,
                            firstDayOfWeek: 'su',
                            disableUntil: {
                                year: this.myDpOptions.disableUntil.year,
                                month: this.myDpOptions.disableUntil.month,
                                day: this.myDpOptions.disableUntil.day
                            }
                        };
                        formControlName.class_endDate.patchValue(items.end_date);
                    } else {
                        formControlName.endDate.patchValue(null);
                    }
                }
            });
        });
        const classIds = selectedClass.map(control => control.class_id);
        if (classIds.length != 0) {
            this.liststudent(classIds);
        }
        this.pruneExpandAssignClassSchedules();
        this.refreshExpandAssignClassSchedules();
        if (this.assignType === '1') {
            this.syncClassContentDateRanges();
        }
    }

    // selectStudent(event) {
    //     console.log(event, 'get ev');
    //     if (event != undefined) {
    //         this.classData = [event];
    //         this.assignForm.controls.specificstudent.patchValue([]);
    //         // this.classbatchid = event.batch_id;
    //         if (event.start_date != '0000-00-00') {
    //             const sd = event.end_date.split('-');
    //             const sdObject: IMyDateModel = {
    //                 isRange: false,
    //                 singleDate: {jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2]))},
    //                 dateRange: null
    //             };
    //             const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
    //             const dropped = dr1.split('-');
    //             const droppedObject: IMyDateModel = {
    //                 isRange: false,
    //                 singleDate: {jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2]))},
    //                 dateRange: null
    //             };
    //             this.assignForm.controls.startDate.patchValue(droppedObject);
    //             this.myDpOptions2 = {};
    //             this.myDpOptions2 = {
    //                 dateRange: false,
    //                 dateFormat: dateOptions.pickerFormat,
    //                 firstDayOfWeek: 'su',
    //                 disableUntil: {
    //                     year: this.myDpOptions.disableUntil.year,
    //                     month: this.myDpOptions.disableUntil.month,
    //                     day: this.myDpOptions.disableUntil.day
    //                 }
    //             };
    //
    //             this.startdate = event.start_date;
    //         } else {
    //             const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
    //             const dropped = dr1.split('-');
    //             const droppedObject: IMyDateModel = {
    //                 isRange: false,
    //                 singleDate: {jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2]))},
    //                 dateRange: null
    //             };
    //             this.assignForm.controls.startDate.patchValue(droppedObject);
    //         }
    //         if (event.end_date != '0000-00-00') {
    //             const sd = event.end_date.split('-');
    //             const sdObject: IMyDateModel = {
    //                 isRange: false,
    //                 singleDate: {jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2]))},
    //                 dateRange: null
    //             };
    //             // this.linkform.controls.endDate.patchValue(sdObject);
    //             this.myDpOptions1 = {};
    //             this.myDpOptions1 = {
    //                 dateRange: false,
    //                 dateFormat: dateOptions.pickerFormat,
    //                 firstDayOfWeek: 'su',
    //                 disableUntil: {
    //                     year: this.myDpOptions.disableUntil.year,
    //                     month: this.myDpOptions.disableUntil.month,
    //                     day: this.myDpOptions.disableUntil.day
    //                 }
    //             };
    //             this.endDate = event.end_date;
    //         } else {
    //             this.assignForm.controls.endDate.patchValue(null);
    //         }
    //         const stObject = {hour: parseInt('00'), minute: parseInt('00'), second: parseInt('00')};
    //         this.assignForm.controls.startTime.patchValue(stObject);
    //         const etObject = {hour: parseInt('23'), minute: parseInt('59'), second: parseInt('00')};
    //         this.assignForm.controls.endTime.patchValue(etObject);
    //         // this.liststudent(event.class_id);
    //     } else {
    //         this.assignForm.controls.endDate.patchValue(null);
    //         this.assignForm.controls.specificstudent.patchValue([]);
    //         this.studentData = [];
    //         this.classData = [];
    //         this.startdate = '';
    //         this.endDate = '';
    //     }
    // }

    teacherFilter(event) {
        console.log(event);
        this.assignForm.controls.classSelect.patchValue([]);
        this.assignForm.controls.specificstudent.patchValue([]);
        this.studentData = [];
        this.assignForm.controls.endDate.patchValue(null);
        if (event != undefined) {
            this.classListData = this.classDataSample.filter((val) => {
                const teacher_id = val.teacher_id.split(',');
                return teacher_id.includes(event.teacher_id);
            });
        } else {
            this.classListData = this.classDataSample;
        }
        console.log(this.classListData, 'classListData');
        console.log(this.classDataSample, 'classDataSample');
    }

    classList() {
        const data = {
            platform: 'web',
            type: '5',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            teacher_id: this.auth.getRoleId() == '4' ? this.auth.getUserId() : '0'
        };
        this.classService.classesList(data).subscribe((successData) => {
                this.classListSuccess(successData);
            },
            (error) => {
                console.error(error, 'error_classLst');
            });
    }

    classListSuccess(successData) {
        if (successData.IsSuccess) {
            this.classListData = successData.ResponseObject;
            this.classDataSample = successData.ResponseObject;
        }
    }

    liststudent(classId) {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            class_id: classId
        };
        this.creatorService.classList(data).subscribe((successData) => {
                this.studentListSuccess(successData);
            },
            (error) => {
                console.error(error, 'error_studentList');
            });
    }

    studentListSuccess(successData) {
        if (successData.IsSuccess) {
            this.studentData = successData.ResponseObject;
            this.studentData = this.studentData.filter((value, index, self) =>
                index === self.findIndex((t) => t.student_id === value.student_id));
            const previousSelectedStudent = this.assignForm.controls.specificstudent.value;
            if (!previousSelectedStudent.length) {
                this.assignForm.controls.specificstudent.patchValue([]);
            } else {
                const filteredSelection = previousSelectedStudent.filter(prev =>
                    this.studentData.some(current => current.student_id === prev));
                this.assignForm.controls.specificstudent.patchValue(filteredSelection);
            }
        }
    }

    teacherList() {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id')
        };
        this.classService.individualTeacherList(data).subscribe((successData) => {
                this.teacherListSuccess(successData);
            },
            (error) => {
                console.log(error, 'error');
            });
    }

    teacherListSuccess(successData) {
        if (successData.IsSuccess) {
            this.teacherListData = successData.ResponseObject;
        }
    }

    contentFolderList() {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            type: '2'
        };
        this.classService.batchList(data).subscribe((successData) => {
                this.contentFolderListSuccess(successData);
            },
            (error) => {
                console.error(error, 'error_batchData');
            });
    }

    contentFolderListSuccess(successData) {
        if (successData.IsSuccess) {
            this.contentFolderListData = successData.ResponseObject;
        }
    }

    dateValidation1() {
        if (this.assignForm.controls.startDate.value != null && this.assignForm.controls.endDate.value != null && this.assignForm.controls.startDate.value != '' && this.assignForm.controls.endDate.value != '') {
            const startdate = this.datePipe.transform(this.assignForm.controls.startDate.value.singleDate.jsDate, 'yyyy-MM-dd');
            const st = startdate.split('-');
            const endDate = this.datePipe.transform(this.assignForm.controls.endDate.value.singleDate.jsDate, 'yyyy-MM-dd');
            const et = endDate.split('-');
            if (st[0] == et [0]) {
                if (st[1] == et [1]) {
                    this.dateValidation = st[2] <= et [2];
                } else {
                    this.dateValidation = st[1] <= et [1];
                }
            } else {
                this.dateValidation = true;
            }
        } else {
            this.dateValidation = true;
        }
    }

    submitAssign(type) {
        // this.dateValidation1();
        const typeSelection = this.assignForm.controls.typeSelection.value;
        let batchId = '';
        let classId = '';
        const assignedForm = this.auth.getSessionData('assignedForm');
        if (assignedForm == 'class') {
            if (this.auth.getSessionData('batchassign') == '1' || this.auth.getSessionData('batchassign') == '3') {
                batchId = this.classData[0].batch_id;
                classId = this.classData[0].class_id;
            } else if (this.auth.getSessionData('batchassign') == '2') {
                batchId = this.assignForm.controls.contentFolder.value;
                classId = '';
            }
        } else if (assignedForm == 'content-Folder') {
            batchId = this.assignForm.controls.contentFolder.value;
            classId = '';
        } else {
            if (typeSelection == '1') {
                batchId = this.classData.length != 0 ? this.classData[0].batch_id : '';
                classId = this.assignForm.controls.classSelect.value.length != 0 ? this.assignForm.controls.classSelect.value.length : '';
            } else {
                const batchValue = JSON.parse(this.auth.getSessionData('selectedbatchId'));
                batchId = batchValue ? (batchValue.length == 0  ? '' : batchValue) : '';
                classId = '';
            }
        }
        const allStudentSelected = this.studentData.length == this.assignForm.controls.specificstudent.value.length;

        const allStudentValue = allStudentSelected || type == '2' || typeSelection == '2' ? '1' : '0';
        const selectedStudentId = allStudentSelected || type == '2' || typeSelection == '2' ? [] :
            this.assignForm.controls.specificstudent.value.length == 0 ? [] : this.assignForm.controls.specificstudent.value.map(items => items.student_id);
        if (classId != '' || batchId != '') {
            if ((allStudentValue == '0' && this.studentData.length != 0) || allStudentValue == '1') {
                if ((allStudentValue == '0' && selectedStudentId.length != 0) || allStudentValue == '1') {
                    this.validateAssignDateRanges();
                    if (this.dateValidation) {
                        const hasMultiContentSelection = this.multiContentId.length > 0;
                        let classDetails = [];
                        if (this.assignType == '1') {
                            this.assignForm.get('dateRanges').value.forEach((control) => {
                                if (hasMultiContentSelection) {
                                    this.multiContentId.forEach((items) => {
                                        const selectedContentDate = this.assignForm.get('classContentDateRanges').value
                                            ?.find((contentRange: any) => contentRange.content_id == items.content_id && contentRange.class_id == control.class_id);
                                        classDetails.push({
                                            content_id: items.content_id,
                                            class_id: control.class_id,
                                            start_date: selectedContentDate?.startDate?.singleDate?.jsDate
                                                ? this.datePipe.transform(selectedContentDate.startDate.singleDate.jsDate, 'yyyy-MM-dd')
                                                : '',
                                            end_date: selectedContentDate?.endDate?.singleDate?.jsDate
                                                ? this.datePipe.transform(selectedContentDate.endDate.singleDate.jsDate, 'yyyy-MM-dd')
                                                : '',
                                            start_time: selectedContentDate?.startTime ? selectedContentDate.startTime : '',
                                            end_time: selectedContentDate?.endTime ? selectedContentDate.endTime : '',
                                            all_student: allStudentValue,
                                            student_id: selectedStudentId.length != 0 ? selectedStudentId : '',
                                            batch_id: '',
                                            auto_review: this.assignForm.controls.releaseScore.value,
                                            notes: '',
                                            download: this.assignForm.controls.downloadcontent.value ? '1' : '0',
                                            allow_feedback: this.assignForm.controls.feedback.value ? '1' : '0',
                                            show_timer: this.assignForm.controls.showTimer.value ? '1' : '0',
                                            is_accessible: this.assignForm.controls.timeRestrict.value ? '1' : '0',
                                            allow_workspace: this.assignForm.controls.workspace.value ? '1' : '0',
                                            is_fullscreen: this.assignForm.controls.is_fullscreen.value ? '1' : '0',
                                            topic_id: this.assignForm.controls.classSelect.value.length <= 1 &&
                                            this.assignForm.controls.topicSelect.value ? this.assignForm.controls.topicSelect.value : ''
                                        });
                                    });
                                } else {
                                    classDetails.push({
                                        content_id: this.contentDetails.content_id,
                                        class_id: control.class_id,
                                        start_date: control.startDate?.singleDate?.jsDate
                                            ? this.datePipe.transform(control.startDate.singleDate.jsDate, 'yyyy-MM-dd') : '',
                                        end_date: control.endDate?.singleDate?.jsDate
                                            ? this.datePipe.transform(control.endDate.singleDate.jsDate, 'yyyy-MM-dd') : '',
                                        start_time: control.startTime ? control.startTime : '',
                                        end_time: control.endTime ? control.endTime : '',
                                        all_student: allStudentValue,
                                        student_id: selectedStudentId.length != 0 ? selectedStudentId : '',
                                        batch_id: '',
                                        auto_review: this.assignForm.controls.releaseScore.value,
                                        notes: '',
                                        download: this.assignForm.controls.downloadcontent.value ? '1' : '0',
                                        allow_feedback: this.assignForm.controls.feedback.value ? '1' : '0',
                                        show_timer: this.assignForm.controls.showTimer.value ? '1' : '0',
                                        is_accessible: this.assignForm.controls.timeRestrict.value ? '1' : '0',
                                        allow_workspace: this.assignForm.controls.workspace.value ? '1' : '0',
                                        is_fullscreen: this.assignForm.controls.is_fullscreen.value ? '1' : '0',
                                        topic_id: this.assignForm.controls.classSelect.value.length <= 1 &&
                                        this.assignForm.controls.topicSelect.value ? this.assignForm.controls.topicSelect.value : ''
                                    });
                                }
                            });
                        } else {
                            classDetails = [{
                                content_id: this.contentDetails.content_id,
                                class_id: this.classData[0]?.class_id,
                                start_date: '',
                                end_date: '',
                                start_time: '',
                                end_time: '',
                                all_student: allStudentValue,
                                student_id: selectedStudentId.length != 0 ? selectedStudentId : '',
                                batch_id: '',
                                auto_review: this.assignForm.controls.releaseScore.value,
                                notes: '',
                                download: this.assignForm.controls.downloadcontent.value ? '1' : '0',
                                allow_feedback : this.assignForm.controls.feedback.value ? '1' : '0',
                                show_timer : this.assignForm.controls.feedback.value ? '1' : '0',
                                allow_workspace : this.assignForm.controls.workspace.value ? '1' : '0',
                                is_fullscreen : this.assignForm.controls.is_fullscreen.value ? '1' : '0',
                                topic_id: this.assignForm.controls.classSelect.value.length <= 1 &&
                                    this.assignForm.controls.topicSelect.value ? this.assignForm.controls.topicSelect.value : ''
                            }];
                        }
                        const data = {
                            platform: 'web',
                            role_id: this.auth.getRoleId(),
                            user_id: this.auth.getUserId(),
                            assign: this.assignType,
                            school_id: this.auth.getSessionData('school_id'),
                            classdetails: classDetails,
                            classroomDetails: [{
                                content_id: this.assignType == '1'
                                    ? (hasMultiContentSelection ? this.multiContentId[0]?.content_id ?? '' : this.contentDetails.content_id)
                                    : [this.contentDetails.content_id],
                                batch_id: batchId,
                                start_date: '',
                                end_date: '',
                                start_time: '',
                                end_time: '',
                            }],
                            editor_type: ''
                        };
                        this.creatorService.addAssignResourse(data).subscribe((successData) => {
                                this.submitSuccess(successData);
                            },
                            (error) => {
                                console.error(error, 'error_submit');
                            });
                    } else {
                        this.toastr.error('End Date Should be greater than Start Date');
                    }
                } else {
                    this.toastr.error('Select Atleast one Student');
                }
            } else {
                this.toastr.error('No Student Available in this class please select all student');
            }
        } else {
            this.toastr.error('Please fill the mandatory field');
        }
    }

    submitSuccess(successData) {
        if (successData.IsSuccess) {
            // this.submitData = successData.ResponseObject;
            this.toastr.success('Class Resource Updated Successfully');
            this.auth.setSessionData('contentType', '');
            console.log(this.auth.getSessionData('assignedForm'), 'ristaAssigned');
            if (this.auth.getSessionData('assignedForm') == 'class') {
                this.auth.removeSessionData('content_assign');
                this.router.navigate(['class/topicsAndCurriculum/1']);
            } else if (this.auth.getSessionData('assignedForm') == 'content-Folder') {
                this.router.navigate(['class/view-assign/2']);
            } else if (this.auth.getSessionData('assignedForm') == 'classRoom') {
                const routedFrom = this.auth.getSessionData('editContentFromClassRoom') ?? '';
                if (routedFrom == 'classRoom') {
                    this.router.navigate(['classroom/list-classroom']);
                    this.auth.removeSessionData('editContentFromClassRoom');
                } else {
                    this.closePopUp.emit('assign');
                }
            } else {
                this.router.navigate(['repository/content-home']);
            }
            this.auth.setSessionData('resourceAccess', false);
            this.auth.removeSessionData('assignedForm');
        } else {
            this.toastr.error(successData.ErrorObject ? successData.ErrorObject : successData.ResponseObject);
            this.assignForm.controls.startDate.patchValue(null);
            this.assignForm.controls.endDate.patchValue(null);
            this.startdate = '';
            this.endDate = '';
            const stObject = {hour: parseInt('00'), minute: parseInt('00'), second: parseInt('00')};
            this.assignForm.controls.startTime.patchValue(stObject);
            const etObject = {hour: parseInt('23'), minute: parseInt('59'), second: parseInt('00')};
            this.assignForm.controls.endTime.patchValue(etObject);
            this.myDpOptions2 = {
                dateRange: false,
                dateFormat: dateOptions.pickerFormat,
                firstDayOfWeek: 'su',
            };
            this.myDpOptions1 = {
                dateRange: false,
                dateFormat: dateOptions.pickerFormat,
                firstDayOfWeek: 'su',
            };
        }
        this.closePopUp.emit();
    }

    classDetailService() {
        // this.commondata.showLoader(true);
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            class_id: this.classData[0].class_id
        };
        this.classService.classDetails(data).subscribe((successData) => {
                this.enterListSuccess(successData);
            },
            (error) => {
                console.error(error, 'error_enter');
            });
    }

    enterListSuccess(successData) {
        if (successData.IsSuccess) {
            // this.commondata.showLoader(false);
            this.auth.setSessionData('classView', true);
            this.auth.setSessionData('card-data', JSON.stringify(successData.ResponseObject));
            this.auth.setSessionData('studentlist', JSON.stringify(successData.ResponseObject[0].students));
            this.auth.setSessionData('studentlist1', JSON.stringify(successData.ResponseObject[0].students));
            if (this.auth.getSessionData('resourceAccess') == 'true') {
                if (this.auth.getSessionData('batchassign') == '1') {
                    this.router.navigate(['class/topicsAndCurriculum/1']);
                }else if (this.auth.getSessionData('batchassign') == '3'){
                    this.router.navigate(['class/topicsAndCurriculum/3']);
                }
            }
        }
    }

    close() {
        this.assignToChoiceOpen = false;
        if (this.auth.getSessionData('assignedForm') == 'class') {
            this.router.navigate(['class/topicsAndCurriculum/1']);
        } else if (this.auth.getSessionData('assignedForm') == 'content-Folder') {
            this.router.navigate(['class/view-assign/2']);
        } else if (this.auth.getSessionData('assignedForm') == 'classRoom') {
            const routedFrom = this.auth.getSessionData('editContentFromClassRoom') ?? '';
            if (routedFrom == 'classRoom') {
                this.router.navigate(['classroom/list-classroom']);
                this.auth.removeSessionData('editContentFromClassRoom');
            } else {
                this.closePopUp.emit();
            }
        } else {
            this.router.navigate(['repository/content-home']);
        }
        this.auth.setSessionData('resourceAccess', false);
        this.auth.removeSessionData('assignedForm');
        this.closePopUp.emit();
    }

    patchValue() {
        console.log(this.classData, 'classData')
        this.assignForm.controls.class.patchValue(this.classData[0].class_name);
        this.assignForm.get('dateRanges').value.forEach((control, index) => {
            const formControlName = this.assignForm['controls'].dateRanges['controls'][index]['controls'];
            formControlName.class_name.patchValue(this.classData[0].class_name ? this.classData[0].class_name : '');
            formControlName.class_id.patchValue(this.classData[0].class_id ? this.classData[0].class_id : '');
            if (this.classData[0].start_date != '0000-00-00') {
                const sd = this.classData[0].start_date.split('-');
                const sdObject: IMyDateModel = {
                    isRange: false,
                    singleDate: { jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2])) },
                    dateRange: null
                };
                const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
                const dropped = dr1.split('-');
                const droppedObject: IMyDateModel = {
                    isRange: false,
                    singleDate: { jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2])) },
                    dateRange: null
                };
                formControlName.startDate.patchValue(droppedObject);
                this.myDpOptions1 = {};
                this.myDpOptions1 = {
                    dateRange: false,
                    dateFormat: dateOptions.pickerFormat,
                    firstDayOfWeek: 'su',
                    disableUntil: {
                        year: parseInt(sd[0]),
                        month: parseInt(sd[1]),
                        day: parseInt(sd[2]) - 1
                    },
                };
                formControlName.class_startDate.patchValue(this.classData[0].start_date);
            } else {
                const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
                const dropped = dr1.split('-');
                const droppedObject: IMyDateModel = {
                    isRange: false,
                    singleDate: { jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2])) },
                    dateRange: null
                };
                formControlName.startDate.patchValue(droppedObject);
            }
            if (this.classData[0].end_date != '0000-00-00') {
                const sd = this.classData[0].end_date.split('-');
                const sdObject: IMyDateModel = {
                    isRange: false,
                    singleDate: { jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2])) },
                    dateRange: null
                };
                this.myDpOptions1 = {};
                this.myDpOptions1 = {
                    dateRange: false,
                    dateFormat: dateOptions.pickerFormat,
                    firstDayOfWeek: 'su',
                    disableUntil: {
                        year: this.myDpOptions.disableUntil.year,
                        month: this.myDpOptions.disableUntil.month,
                        day: this.myDpOptions.disableUntil.day
                    },
                };
                formControlName.class_endDate.patchValue(this.classData[0].end_date);
            } else {
                formControlName.endDate.patchValue(null);
            }
        });

        // if (this.classData[0].start_date != '0000-00-00') {
        //     const sd = this.classData[0].start_date.split('-');
        //     const sdObject: IMyDateModel = {
        //         isRange: false,
        //         singleDate: {jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2]))},
        //         dateRange: null
        //     };
        //     const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
        //     const dropped = dr1.split('-');
        //     const droppedObject: IMyDateModel = {
        //         isRange: false,
        //         singleDate: {jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2]))},
        //         dateRange: null
        //     };
        //     this.assignForm.controls.startDate.patchValue(droppedObject);
        //     this.myDpOptions1 = {};
        //     this.myDpOptions1 = {
        //         dateRange: false,
        //         dateFormat: dateOptions.pickerFormat,
        //         firstDayOfWeek: 'su',
        //         disableUntil: {
        //             year: parseInt(sd[0]),
        //             month: parseInt(sd[1]),
        //             day: parseInt(sd[2]) - 1
        //         },
        //     };
        //     this.startdate = this.classData[0].start_date;
        // } else {
        //     const dr1 = this.datePipe.transform(this.model.singleDate.jsDate, 'yyyy-MM-dd');
        //     const dropped = dr1.split('-');
        //     const droppedObject: IMyDateModel = {
        //         isRange: false,
        //         singleDate: {jsDate: new Date(parseInt(dropped[0]), parseInt(dropped[1]) - 1, parseInt(dropped[2]))},
        //         dateRange: null
        //     };
        //     this.assignForm.controls.startDate.patchValue(droppedObject);
        //     // this.linkform.controls.startDate.patchValue(null);
        // }
        // if (this.classData[0].end_date != '0000-00-00') {
        //     const sd = this.classData[0].end_date.split('-');
        //     const sdObject: IMyDateModel = {
        //         isRange: false,
        //         singleDate: {jsDate: new Date(parseInt(sd[0]), parseInt(sd[1]) - 1, parseInt(sd[2]))},
        //         dateRange: null
        //     };
        //     // this.linkform.controls.endDate.patchValue(sdObject);
        //     this.myDpOptions1 = {};
        //     this.myDpOptions1 = {
        //         dateRange: false,
        //         dateFormat: dateOptions.pickerFormat,
        //         firstDayOfWeek: 'su',
        //         disableUntil: {
        //             year: this.myDpOptions.disableUntil.year,
        //             month: this.myDpOptions.disableUntil.month,
        //             day: this.myDpOptions.disableUntil.day
        //         },
        //     };
        //     this.endDate = this.classData[0].end_date;
        // } else {
        //     this.assignForm.controls.endDate.patchValue(null);
        // }
        const stObject = {hour: parseInt('00'), minute: parseInt('00'), second: parseInt('00')};
        this.assignForm.controls.startTime.patchValue(stObject);
        const etObject = {hour: parseInt('23'), minute: parseInt('59'), second: parseInt('00')};
        this.assignForm.controls.endTime.patchValue(etObject);
        this.contentScheduleMyDpOptionsStart = {...this.myDpOptions2, appendSelectorToBody: true};
        this.contentScheduleMyDpOptionsEnd = {...this.myDpOptions1, appendSelectorToBody: true};
        this.pruneExpandAssignClassSchedules();
        this.refreshExpandAssignClassSchedules();
        if (this.assignType === '1') {
            this.syncClassContentDateRanges();
        }
    }
}
